export const UI_OPEN_COLLECTION_PREVIEW_MODAL =
  "UI/COLLECTION_PREVIEW_MODAL/OPEN";
export const UI_CLOSE_COLLECTION_PREVIEW_MODAL =
  "UI/COLLECTION_PREVIEW_MODAL/CLOSE";
